export default __webpack_public_path__ + "static/media/map-type-satellite.dad5f874.png";